// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2FC0W","author":"Table_author__1TPqa","authorImage":"Table_authorImage__165m6","unreadRow":"Table_unreadRow__2JXjZ"};